import { encodeArk } from '@fs/zion-ark'
import { i18n } from '@fs/zion-locale'
import { getApidImageUrl } from '../services/das/dasService'

export const getImagesFromApidList = (apidList) => {
  const filteredApids = apidList.filter((apid) => !apid.toLowerCase().includes('tomato'))
  const encoded = filteredApids
    .map((apid, originalIndex) => {
      try {
        return {
          srcSet: {
            0: getApidImageUrl(apid, 'thumb_p200.jpg'),
            500: getApidImageUrl(apid, 'image.xml'),
          },
          id: apid,
          ark: encodeArk(apid),
          index: originalIndex,
        }
      } catch (error) {
        console.error(`Failed to encode ARK for APID: ${apid}`, error)
        return null
      }
    })
    .filter((image) => image !== null)
  // TODO: RIP also uses this util — the alt text change from APID to "Image N of M" affects
  // RIP's ribbon and download overlay. Verify RIP behavior is acceptable before removing.
  // In Lightyear the grid also sets an aria-label via GroupImage, so the label is built twice
  // under two different keys; consolidate once zion-image-viewer exposes position natively.
  // ORAL_GEN groups go through getApidsFromOralGen and still use the raw APID.
  return encoded.map((image, i) => ({
    ...image,
    alt: i18n.t('getImagesFromApidList.imageAlt', 'Image {index} of {total}', { index: i + 1, total: encoded.length }),
  }))
}
